module.exports = __webpack_public_path__ + "media/images/v2/icon7-c241a6d7b118e2db60b499553573e1be.png";